@if (graphGenerated) {
  <div fxLayout="column" fxLayoutAlign="center center" class="graph-wrapper">
    <canvas
      #chart
      baseChart
      [type]="chartType"
      [datasets]="chartData"
      [labels]="chartLabels"
      [options]="chartOptions"
      [legend]="legend"
      (chartClick)="onChartClick($event)"
      tabindex="0"
      (keydown)="handleKeyDown($event)">
    </canvas>
    @if (showTooltip) {
      <app-graph-details-modal
        [infoSettings]="infoSettings">
      </app-graph-details-modal>
    }
  </div>
}
